import { BillingTransferRequest } from "@common/dto/billing/transfer-request.dto";
import { Organization } from "@common/types/organization";
import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { useBillingTransferUrls } from "@hooks/billing/useBillingTransferUrls";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useSettings } from "@components/settings/SettingsProvider";
import styles from "./FlatRateBilling.module.scss";

interface PendingTransferRequestProps {
    request: BillingTransferRequest;
    organization: Organization;
}

export const PendingTransferRequest: React.FC<PendingTransferRequestProps> = ({
    request,
    organization,
}) => {
    const { close } = useSettings();
    const navigate = useStateAwareNavigate();
    const { acceptTransferRequest, rejectTransferRequest } =
        useBillingTransferUrls(request);

    const handleClick = (url: string) => {
        close();
        navigate(url);
    };

    return (
        <section className={classNames(styles.section, styles.transferRequest)}>
            <main>{organization.name} has requested billing ownership</main>
            <aside className={styles.actions}>
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => handleClick(acceptTransferRequest)}
                >
                    Accept
                </Button>
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => handleClick(rejectTransferRequest)}
                >
                    Reject
                </Button>
            </aside>
        </section>
    );
};
